import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";

const gridLocation = 'shipmentReport';


@observer
export default class ShipmentReport extends PageAncestor<PageProps, undefined> {

  static module = MODULE.shipment;
  static title = loc.i18n`Reports`;
  static icon = 'line-chart';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ShipmentReport#fetchData(%s)", gridLocation);

    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }







  render() {
    let {params, query} = this.props;


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
      </GridCompConnected>
    );
  }


}



// WEBPACK FOOTER //
// ./src/shipment/page/shipmentReport.tsx